import React from 'react';

import { cn } from '~/lib/utils';

import { CARD_SKELETON_HEIGHT } from './constants';

interface AccessCardSkeletonProps {
  width: number;
  showTagPlaceholder?: boolean;
  className?: string;
}

export function AccessCardSkeleton({
  width,
  showTagPlaceholder = false,
  className
}: AccessCardSkeletonProps) {
  return (
    <div
      aria-hidden
      style={{ width, height: CARD_SKELETON_HEIGHT }}
      className={cn(
        'flex flex-col justify-between gap-4 rounded border border-gray-200 bg-white p-6',
        className
      )}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-2 w-2 rounded-full bg-gray-100 animate-pulse" />
          <div className="h-3 w-16 rounded bg-gray-100 animate-pulse" />
        </div>
        {showTagPlaceholder ? (
          <div className="h-5 w-12 rounded bg-gray-100 animate-pulse" />
        ) : null}
      </div>

      <div className="flex flex-1 items-center gap-4">
        <div className="h-12 w-12 shrink-0 rounded bg-gray-100 animate-pulse" />
        <div className="flex flex-1 flex-col gap-2">
          <div className="h-4 w-28 rounded bg-gray-100 animate-pulse" />
          <div className="h-3 w-36 rounded bg-gray-100 animate-pulse" />
        </div>
      </div>
    </div>
  );
}
